<template>
  <div class="home-view internal">
    <section class="form">
      <div class="container">
        <h1 class="title-default">Apartamento Decorado</h1>
      </div> <!-- /.container -->
    </section> <!-- /.form -->

    <section class="slide-status" v-if="info && info.fotos && info.fotos.length">
      <!-- <h2>Status de Obra</h2> -->

      <a href="javascript:void(0)" class="btn-carousel -prev" @click="prevStatus()" :class="{ '-deactivated': status.activeIndex == 0 }"><i class="icon -arrow-left-white"></i></a>

      <swiper :options="status.options" ref="swiperStatus" @slideChange="slideChangedStatus()">
        <template>
          <swiper-slide v-for="(item, i) in info.fotos" :key="i">
            <figure @click="toggleModal()">
              <!-- <a href="javascript:void(0)" class="icon -zoom"></a> -->

              <img :src="urlFiles + 'emp/' + empId + '/' + info.blocoId + '/' + item.arquivo" alt="">
            </figure>
          </swiper-slide>
        </template>
      </swiper>

      <a href="javascript:void(0)" class="btn-carousel -next" @click="nextStatus()" :class="{ '-deactivated': status.activeIndex == info.fotos.length - 1 }"><i class="icon -arrow-right-white"></i></a>
    </section> <!-- /.slide-status -->

    <section v-else-if="loading" class="status">
      <h2>Carregando...</h2>
    </section>

    <section v-else class="status">
      <h2>Não existe apartamento decorado cadastrado para o seu empreendimento.</h2>
    </section>

    <transition name="fade">
      <Modal :data="optsModal" @close="toggleModal()" v-if="optsModal.render" />
    </transition>
  </div>
</template>

<script>
import Vue from 'vue'
import PagesService from '@/services/Pages'
import Modal from '@/components/Modal'

export default {
  name: 'decorado',

  components: {
    Modal
  },

  data () {
    const data = {
      info: null,
      empId: 0,

      loading: true,

      status: {
        options: {
          autoHeight: true
        },

        activeIndex: 0
      }, // status

      optsModal: {
        type: 'GALLERY',
        urlBase: '',
        show: true,
        render: false,
        activeIndex: 0
      },

      urlFiles: Vue.prototype.urlFiles
    }

    return data
  }, // data()

  mounted () {
    this.load()
  }, // mounted()

  methods: {
    async load () {
      try {
        let { contratoAtual } = this.$store.state
        this.empId = contratoAtual.empreendimentoIdWeb
        let xhr = await PagesService.getEmp(this.empId)

        if (xhr && xhr.blocos && xhr.blocos.length) {
          let objGaleria = xhr.blocos.find(item => item.tipo.codigo === 'GF')
          let galeriaDecorado = objGaleria.galerias.find(item => item.titulo && item.titulo.toLowerCase() === 'decorado')

          this.info = galeriaDecorado
          this.optsModal.arr = galeriaDecorado.fotos
          this.loading = false
        }
      } catch (e) {
        console.error('Falha ao carregar empreendimento', e)
      }
    }, // load()

    slideChangedStatus () {
      this.status.activeIndex = this.swiperStatus.activeIndex
      this.optsModal.activeIndex = this.swiperStatus.activeIndex
    }, // slideChangedStatus()

    prevStatus () {
      this.swiperStatus.slidePrev()
    }, // prevStatus()

    nextStatus () {
      this.swiperStatus.slideNext()
    }, // nextStatus()

    isMobile () {
      return screen.width <= 1024
    }, // isMobile()

    toggleModal (i) {
      this.optsModal.urlBase = `emp/${this.empId}/${this.info.blocoId}/`
      this.optsModal.render = !this.optsModal.render
    } // toggleModal()
  }, // methods

  computed: {
    swiperStatus () {
      return this.$refs.swiperStatus.swiper
    } // swiperStatus()
  } // computed
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  section
    &.form
      padding-bottom: 10px

    &.status
      h2
        text-align: center
        font-size: 18px
        margin-bottom: 40px

    @media (max-width: 1024px)
      &.status
</style>
